
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RecruitmentPage = lazy(() => import('../pages/recruitment/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/recrutement',
    element: <RecruitmentPage />,
  },
  {
    path: '/galerie',
    element: <GalleryPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
